module.exports = __webpack_public_path__ + "img/dvr.a8fddf1a.svg";